/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { documentAdminControllerCancelStuckProcessings } from "./documentAdminControllerCancelStuckProcessings";
import { documentAdminControllerPreviewOrphanedDocumentReconciliation } from "./documentAdminControllerPreviewOrphanedDocumentReconciliation";
import { documentAdminControllerPreviewStuckProcessings } from "./documentAdminControllerPreviewStuckProcessings";
import { documentAdminControllerReconcileOrphanedDocuments } from "./documentAdminControllerReconcileOrphanedDocuments";

export function documentAdminService() {
  return { documentAdminControllerPreviewOrphanedDocumentReconciliation, documentAdminControllerReconcileOrphanedDocuments, documentAdminControllerPreviewStuckProcessings, documentAdminControllerCancelStuckProcessings }
}